<template>
  <div>
    <v-layout wrap align-center>
      <v-container fluid>
        <v-layout row child-flex wrap>
          <v-flex d-flex xs2 sm1 class="grey lighten-2">
            <div class="text-center">
              <h3 class="primary-color">2</h3>
            </div>
          </v-flex>
          <v-flex d-flex xs10 sm11 class="grey lighten-3">
            <div>
              <h3 class="primary-color">Custos com energia</h3>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout
      v-for="(conta, index) in projeto.contas"
      v-bind:key="index"
      row
      wrap
    >
      <v-flex xs12 d-flex>
        <h4>Conta de energia {{ index + 1 }}</h4>
      </v-flex>
      <v-flex xs12 sm3 md2>
        <v-radio-group label="Tipo de imóvel" v-model="conta.tipo" column style="margin-top: 0px;">
          <v-radio label="Residencial" value="0"></v-radio>
          <v-radio label="Comercial" value="1"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm4 md3 d-flex>
        <v-text-field
          label="Valor mensal"
          prefix="R$"
          v-model.lazy="conta.valor"
          v-money="money"
          :rules="currencyValueRules"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4 md3 d-flex>
        <v-text-field
          label="Consumo mensal"
          type="number"
          suffix="KwH"
          v-model="conta.consumoMensal"
          :rules="valueRules"
          @change="loadFiltros(conta, index)"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4 md3 d-flex>
        <v-text-field
          ref="tarifa"
          label="Valor kWh de sua cidade (R$)"
          prefix="R$"
          v-money="money"
          v-model.lazy="conta.consumoKwh"
          :rules="currencyValueRules"
          required
        ></v-text-field>
      </v-flex>
      <!--v-flex>
          <v-btn text icon v-if="projeto.contas.length > 1" @click="removeBill(index)">
            <v-icon color="red" class="fa fa-trash"></v-icon>
          </v-btn>
        </!-v-flex>-->
    </v-layout>
    <v-layout v-if="projeto.contas.length < 5" row wrap mb-3>
      <v-flex xs12 class="text-xs-center text-sm-left" style="padding: 0px;">
        <v-btn color="#50BED3" class="white--text" @click="addBill()"
          >ADICIONAR CONTA</v-btn
        >
      </v-flex>
      <v-flex class="text-xs-right">
        <v-card color="grey lighten-3" flat>
          <v-card-text class="text-center">
            <p>
              *Gastos com energia:
              {{
                this.projeto.contas
                  .reduce(
                    (a, b) =>
                      Number(a) +
                      Number(b.valor.replace(/[d,.?!]+/g, "")) / 100,
                    0
                  )
                  .toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
              }}.
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card color="grey lighten-3" flat>
          <v-card-text class="text-center">
            <p>
              *Consumo:
              {{
                this.projeto.contas.reduce(
                  (a, b) => Number(a) + Number(b.consumoMensal),
                  0
                )
              }}
              KwH
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { VMoney } from "v-money";

export default {
  name: "ProjectEnergyCost",
  computed: mapGetters(["projeto"]),
  props: ["type"],
  mounted() {
    if (this.type == "create") {
      this.projeto.contas = [
        { tipo: "0", valor: "", consumoMensal: "", consumoKwh: "" },
      ];
    }
  },
  methods: {
    ...mapActions([
      "addBill",
      "removeBill",
      "calculatePotencia",
      "fetchSelectors",
      "clearFiltros",
    ]),
    currencyToNumber(value) {
      return Number(value.replace(/[d,.?!]+/g, "")) / 100;
    },
    async loadFiltros(conta, index) {
      try {
        if (Number(conta.consumoMensal) == 0) return;
        let tarifa = (
          Number(conta.valor.toString().replace(/[d,.?!]+/g, "")) /
          100 /
          Number(conta.consumoMensal)
        ).toFixed(2);
        conta.consumoKwh = tarifa;
        this.$refs.tarifa[index].$el.getElementsByTagName("input")[0].value =
          tarifa;
      } catch {}

      this.clearFiltros();
      await this.calculatePotencia();
      this.fetchSelectors();
    },
  },
  directives: { money: VMoney },
  data() {
    return {
      valueRules: [
        (v) => !!v || "Valor é obrigatório",
        (v) => v > 0.0 || "Valor deve ser um número positivo",
      ],
      currencyValueRules: [
        (v) => (!!v && v != 0.0) || "Valor é obrigatório",
        (v) =>
          this.currencyToNumber(v) > 0.0 || "Valor deve ser um número positivo",
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
    };
  },
};
</script>

<style scoped>
</style>
